import { defineStore } from 'pinia';
import FetchData from "@/utils/FetchData";
import router from '@/router';
import { useUserStore } from '@/store/userStore.js';

// Global toast instance - will be set by main.js
let globalToast = null;

export const setGlobalToast = (toast) => {
  globalToast = toast;
};

export const useDebugStore = defineStore('debugStore', {
  state: () => ({
    showPageDebug: false,
    showPartDebug: null,
    showPartDetailDebug: null,
    lastRequest: null,
    heartbeatTriggered: false,
    TranslateMode: false
  }),
  actions: {
    async triggerHeartbeat() {
      if (this.heartbeatTriggered) {
        return;
      }
      this.heartbeatTriggered = true;
      let route = "HeartBeat";
      let method = "POST";
      let config = {
        currentRoute: router.currentRoute.value.path
      };
      try {
        const response = await FetchData(config, route, method);
        if(!response.success){
          this.HandleHeartBeatAction(response);
        }
      } catch (error) {
        console.error('Error during heartbeat:', error);
      } finally {
        // set to false after 2 seconds
        setTimeout(() => {
          this.heartbeatTriggered = false;
        }, 2000);
      }
    },
    HandleHeartBeatAction(data) {
      if(data.action == "banned"){
        const userStore = useUserStore();
        
        // Show toast notification about the ban
        if (globalToast) {
          globalToast.add({
            severity: 'error',
            summary: 'Account Banned',
            detail: 'Your account has been banned. You have been logged out automatically.',
            life: 5000
          });
        }
        
        // user was banned and needs to be logged out
        userStore.logout();
        router.push('/login');
      }
    }
  },
});